import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import { saveAs } from "file-saver";

/**
 * Returns a function that triggers an Excel download of publisher purchased/subscribed books.
 * Uses current filter params. Call with (params, publisherId?) to export.
 *
 * @returns {(params: object, publisherId?: string) => Promise<void>}
 */
const useExportPublisherPurchasedBooks = () => {
	const { accessToken } = useTokenStore();

	const exportToExcel = async (params = {}, publisherId = "") => {
		const instance = await InitApi({ accessToken });
		const queryParams = {
			from_date: params.fromDate || params.from_date || "2021-06-01",
			to_date: params.toDate || params.to_date || new Date().toISOString().slice(0, 10),
			revenue_line: params.revenueLine || params.revenue_line || "purchase",
			category_is: params.categoryIs || params.category_is,
			search_term: params.searchTerm || params.search_term,
		};
		if (publisherId) {
			queryParams.publisher_id = publisherId;
		}
		const cleaned = deleteEmptyObjects({ ...queryParams });

		const url = "books/publisher-purchased/export";
		const res = await instance.get(url, {
			params: cleaned,
			responseType: "blob",
		});

		const blob = new Blob([res.data], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		saveAs(blob, "publisher-purchased-books.xlsx");
	};

	return exportToExcel;
};

export default useExportPublisherPurchasedBooks;
